(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('ListFilterService', ListFilterService);

    function ListFilterService(lodash, GenericModel, SELECT_CONSTANT, SelectListFilterService, FilterListFilterService, $timeout, $location) {
        return function () {
            var mem = {},
                selectService = null,
                filterService = null;
            return {
                init: init,
                destroy: destroy,
                sync: sync,
                toggleSelectRow: toggleSelectRow,
                toggleSelectAll: toggleSelectAll,
                getFilterService: getFilterService,
                refreshGrid: refreshGrid,
                getSelectedModel: getSelectedModel,
                getSelectedModelKeys: getSelectedModelKeys,
                clearSelected: clearSelected,
                closeDetailPanel: closeDetailPanel,
                showDetailView: showDetailView,
                hideDetailView: hideDetailView,
                emitDataItemEvent: emitDataItemEvent,
                getRowButtonVisibility: getRowButtonVisibility,
                getChildInfoVisibility: getChildInfoVisibility,
                updateToolbarButtons: updateToolbarButtons,
                setExternalGridRefreshFunc: setExternalGridRefreshFunc,
                getData: getData,
                setData: setData,
                updateRecord: updateRecord,
                getAllDataItems: getAllDataItems,
                setExternalStatus: setExternalStatus,
                getExternalStatus: getExternalStatus,
                generateResourceOption: generateResourceOption,
                setDatasourceUrl: setDatasourceUrl,
                getGrid: getGrid,
                setSearchText: setSearchText,
                toggleSelectable: toggleSelectable,
                setPage: setPage,
                getCurrentPipeline: getCurrentPipeline,
                setPipelineData: setPipelineData,
                getPipelineData: getPipelineData,
                getHasPipeline: getHasPipeline,
                toggleFilterSidebar: toggleFilterSidebar,
            };

            // <editor-fold desc='Init Stuff'>
            function init(pageData, listFilterOption, $scope) {
                mem = {
                    pageData: pageData,
                    options: listFilterOption,
                    currentPage: {
                        selected: [],
                        total: 0,
                    },
                    currentScope: $scope
                };


                if (lodash.has(mem, 'options.toolbar') && mem.options.toolbar !== false) {
                    const selectionButtons = lodash.get(listFilterOption.toolbar, 'selection.buttons', []);
                    const additionalButtons = lodash.get(listFilterOption.toolbar, 'selection.additionals', []);
                    const conditionalButtons = lodash.get(listFilterOption.toolbar, 'selection.conditionals', []);
                    const searchBarConfig = lodash.get(listFilterOption.toolbar, 'searchBarConfig', {
                        simple: true,
                    });

                    lodash.set(
                        mem.pageData,
                        'toolbar',
                        angular.merge(
                            {
                                activated: true,
                                selection: {
                                    selectAllFlag: SELECT_CONSTANT.NONE,
                                    selected: [],
                                    select_all: false,
                                },
                                hasSelectionButton: (!lodash.isEmpty(selectionButtons) || !lodash.isEmpty(additionalButtons) || !lodash.isEmpty(conditionalButtons)),
                                // searchBarConfig: searchBarConfig,
                            },
                            listFilterOption.toolbar || {}
                        )
                    );
                    // if (lodash.has(mem, 'options.status_selection')) {
                    //     lodash.set(mem.pageData.toolbar, 'selection.buttons', []);
                    //     delete(mem.pageData.toolbar.selection.additional);
                    // }
                    selectService = new SelectListFilterService(mem);
                }

                if (!lodash.isEmpty(lodash.get(listFilterOption, 'view_options', false))) {
                    lodash.set(mem, 'pageData.view_options', listFilterOption.view_options);
                }

                filterService = new FilterListFilterService(mem);
                if (lodash.has(mem, 'options.filters')) {
                    filterService.init();
                    filterService.getFilterList();

                    // TODO: @JAG
                    // mem.pageData.filters.label.total_count = "{0} Clients";
                    // mem.pageData.filters.label.view_create = "Create view";
                    // mem.pageData.filters.label.view_clone = "Clone view";
                    // mem.pageData.filters.label.view_make_default = "Make this view default";
                    // mem.pageData.filters.label.view_export = "Export all in view";
                    // mem.pageData.filters.label.view_report = "Create report from view";
                }

                // mem.pageData.filter_options = {
                //   options: [
                //       { name: 'test1', label: 'test 1' },
                //       { name: 'test2', label: 'test 2' },
                //       { name: 'test3', label: 'test 3' },
                //       { name: 'test4', label: 'test 4' },
                //   ],
                //   operator: 'eq'
                // };

                if (lodash.has(mem, 'options.no_record_options')) {
                    lodash.set(mem, 'pageData.no_record_options', mem.options.no_record_options);
                }

                initDetailPanel();
                initViewOptions();
                initGrid();
                initFilterView();
                initSelectOnRowButton();
                $timeout(function () {
                    if (mem.pageData.detailPanel.toggleState === true) {
                        if (lodash.has(mem.pageData.detailPanel, 'hideColumnsOnActive') && mem.pageData.detailPanel.hideColumnsOnActive.length > 0) {
                            mem.pageData.detailPanel.hideColumnsOnActive.map(function (fieldName) {
                                mem.pageData.grid.hideColumn(fieldName);
                            });
                        }
                    }
                })
            }

            function initViewOptions() {
                if (lodash.has(mem.options, 'filter_options.options')) {
                    lodash.set(mem.pageData, 'filter_options', mem.options.filter_options);
                    lodash.forEach(mem.options.filter_options.options, function (filterViewOption) {
                        lodash.set(mem.pageData.view_options_filters, filterViewOption.name, filterViewOption.default || false);
                    });
                }
                if (lodash.has(mem.options, 'entity_view')) {
                    lodash.set(mem, 'pageData.entity_view', mem.options.entity_view);
                }
            }

            function emitDataItemEvent(actionName, dataItem) {
                const prefix = lodash.get(mem.options, 'dataitem_event_prefix', 'action.list-filter.dataitem.action');
                const eventName = [prefix, actionName].join('.');
                mem.currentScope.$emit(eventName, dataItem);

                var selectOnRowButtonListeners = lodash.get(mem, 'options.selectOnRowButtonListeners', []);
                lodash.forEach(selectOnRowButtonListeners, function (selectOnRowButtonListener) {
                    selectOnRowButtonListener(actionName, dataItem);
                });
            }

            function getRowButtonVisibility(type, dataItem) {
                const rules = lodash.get(mem.options, 'row_button_rules', {});
                if (!lodash.has(rules, type)) return true;
                const rule = rules[type];

                if (typeof rule === 'string') {
                    return lodash.get(dataItem, rules[type], false);
                }
                if (typeof rule === typeof {}) {
                    const key = lodash.get(rule, 'key', '');
                    const value = lodash.get(dataItem, key, false);
                    if (lodash.has(rule, 'matches')) {
                        return value === rule.matches;
                    }
                    return !!value;
                }
                return true;

            }

            function getChildInfoVisibility(valueKey, ruleCheck, dataItem) {
                if (!valueKey || !ruleCheck) return false;
                if (typeof valueKey !== 'string' || typeof ruleCheck !== 'string') return false;

                var hasValue = lodash.get(dataItem, valueKey, false);
                var hasRule = lodash.get(dataItem, ruleCheck, false);

                if (!hasValue || !hasRule) return false;

                return true;
            }

            function destroy() {
                mem = {};
                selectService = null;
                filterService = null;
            }

            function sync(vm) {
                vm.pageData = mem.pageData;
            }

            function initFilterView() {
                mem.pageData.filterView = lodash.get(mem, 'options.filter_options', false);
            }

            function initDetailPanel() {
                mem.pageData.detailPanel = lodash.get(mem, 'options.detail_panel', false);
                if (!mem.pageData.detailPanel) {
                    return false;
                }
                if (typeof mem.pageData.detailPanel === typeof false) {
                    mem.pageData.detailPanel = {
                        toggleState: false
                    };
                } else {
                    const alwaysOn = lodash.get(mem, 'options.detail_panel.always_on', false);
                    lodash.set(mem.pageData, 'detailPanel.toggleState', alwaysOn);
                    lodash.set(mem.pageData, 'detailPanel.alwaysOn', alwaysOn);
                }
            }


            function initGrid() {
                const gridClass = lodash.get(mem.options, 'grid.options.classes', {});
                if (lodash.has(mem.options, 'grid.options.showHeader')) {
                    if (!mem.options.grid.options.showHeader) {
                        const hideGridHeaderClass = ' hide-grid-header';
                        if (lodash.has(gridClass, 'grid')) {
                            lodash.set(gridClass, 'grid', gridClass.grid + hideGridHeaderClass);
                        } else {
                            lodash.set(gridClass, 'grid', hideGridHeaderClass);
                        }
                    }
                }
                lodash.set(mem.pageData, 'classes', gridClass);

                mem.pageData.gridOption = angular.merge(
                    prepareGridOption(mem.options.grid.options),
                    {
                        dataSource: prepareDatasource(mem.options.grid.datasource)
                    },
                    {
                        // please remove this object after sorting is implemented,
                        // things to take note.
                        // 1. Columns without "field" key will automatically treated as not sortable by kendo
                        // 2. Columns can contain field "sortable" with value "false" for it not to be sortable
                        // 3. May need a different design to tell user that this column is not sortable.
                        dataSource: {
                            serverSorting: true
                        },
                        dataBound: lodash.get(mem, 'options.grid.options.serverGrouping') ?
                            function (e) {
                            } : function (e) {
                                $timeout(function () {
                                    renderActive();
                                }, 300);
                                $('.k-i-collapse').click(function (e) {
                                    var dirtyGroupText = $(e.target).parent().text().trim();
                                    var splitGroupText = dirtyGroupText.split(':');
                                    var groupValue = lodash.last(splitGroupText).trim();

                                    var hasRows = $('tr[role-group*="' + groupValue + '"]').length;
                                    if (hasRows) {
                                        var firstRow = $('tr[role-group*="' + groupValue + '"]');
                                        var isCurrentlyHidden = firstRow.css('display') === 'none';

                                        if (isCurrentlyHidden) {
                                            $('tr[role-group*="' + groupValue + '"]').show();
                                        } else {
                                            $('tr[role-group*="' + groupValue + '"]').hide();
                                        }
                                    }
                                });
                            },
                        // ,
                        // sortable: {
                        //     allowUnsort: true
                        // }

                    }
                );
            }

            function initSelectOnRowButton() {
                if (lodash.has(mem, 'options.select_on_row_button')) {
                    var selectOnRowButton = lodash.get(mem, 'options.select_on_row_button', {});
                    var select = lodash.get(selectOnRowButton, 'select', null);
                    var listener = lodash.get(selectOnRowButton, 'listener', null);
                    var clearQueryParams = lodash.get(selectOnRowButton, 'clear_query_params', []);

                    if (!!select && !!listener) {
                        var rowButtonRules = lodash.get(mem, 'options.row_button_rules', []);

                        if (typeof listener === 'string') {
                            listener = lodash.keys(rowButtonRules);
                        }

                        listener = lodash.pull(listener, select);

                        var selectOnRowButtonListeners = lodash.map(listener, function (oListener) {
                            return (function (select, oListener, clearQueryParams) {
                                return function (action, dataItem) {
                                    if (action === oListener) {

                                        var currentDataItemId = lodash.get(mem, 'pageData.detailPanel.dataItem.id', -1);
                                        var isSameDataItem = currentDataItemId === lodash.get(dataItem, 'id', -2);

                                        if (select === 'preview' && !isSameDataItem) {
                                            _.forEach(clearQueryParams, function (clearQueryParam) {
                                                $location.search(clearQueryParam, null);
                                            });
                                            showDetailView(dataItem);
                                        }
                                        emitDataItemEvent(select, dataItem);
                                    }
                                };
                            })(select, oListener, clearQueryParams);
                        });
                        mem.options.selectOnRowButtonListeners = selectOnRowButtonListeners;
                    }
                }
            }

            // </editor-fold>

            // <editor-fold desc='Grid Stuff'>
            function readGrid(readOptions) {
                mem.pageData.grid_refreshing = true;
                triggerExternalGridRefreshFunc();
                var isFirstLoad = lodash.get(mem, 'currentPage.init', true);
                mem.currentPage = {
                    selected: [],
                    total: 0,
                };

                // getAppliedFilters();
                // if (lodash.has(mem, 'pageData.filters.pipeline') && (mem.pageData.filters.pipeline !== null)) {
                //     // if (mem.pageData.filters.pipeline.value !== ['all']) {
                //     const selectValues = lodash.difference(mem.pageData.filters.pipeline.value, ['all']);
                //     if (selectValues.length > 0) {
                //         const selectFilter = angular.extend({}, mem.pageData.filters.pipeline, {
                //             value: selectValues
                //         });
                //         appliedFilters.push(selectFilter);
                //     }
                // }
                //
                // var myOptions = {
                //     filter: {
                //         applied: appliedFilters,
                //         pipeline: mem.pageData.filters.pipeline || {},
                //     },
                // };

                var myOptions = {
                    filter: filterService.getAppliedFilters(),
                };


                if (typeof filterService.getSort === typeof function () {
                }) {
                    myOptions.sort = filterService.getSort();
                } else {
                    // filterService.getSort will be null on load. This is to apply default sort on load
                    if (lodash.has(mem.options, 'toolbar.sort.default')) {
                        myOptions.sort = [mem.options.toolbar.sort.default];
                    }
                }

                var method = '', datasource = '';
                var includePipeline = true;
                if (filterService.hasAppliedFilters(includePipeline)) {
                    if (lodash.has(mem.options, 'filters.datasource')) {
                        method = mem.options.filters.datasource.filter.method;
                        datasource = mem.options.filters.datasource.filter.url;
                    } else {
                        method = 'search';
                        datasource = mem.url + "/filter";
                    }
                } else {
                    var clearFilter = lodash.get(mem.options.filters, 'datasource.clear_filter', null);
                    if(clearFilter){
                        method = clearFilter.method;
                        datasource = clearFilter.url;
                    }else{
                        method = 'query';
                        datasource = mem.url;
                    }
                }


                var data = generateResourceOption(readOptions.data, myOptions, method);

                var model = new GenericModel(datasource);
                model[method](data).$promise.then(function (res) {
                    if (lodash.has(mem, 'options.toolbar') && !!mem.options.toolbar) {
                        selectService.prepareSelected(res);
                    }

                    var rows = lodash.get(res, 'rows', []);
                    var hasRows = rows.length;
                    var isAlwaysOn = lodash.get(mem, 'options.detail_panel.always_on', false);
                    var smartDetailPanel = lodash.get(mem, 'options.detail_panel.smart_detail_panel', false);
                    if (isAlwaysOn || smartDetailPanel) {
                        if (hasRows) {
                            var currentlySelectedID = lodash.get(mem, 'pageData.detailPanel.dataItem.select_id', null);
                            var rowExist = lodash.findIndex(rows, {select_id: currentlySelectedID}) >= 0;

                            if (smartDetailPanel) {
                                if (!rowExist && mem.pageData.detailPanel.dataItem) {
                                    loadDetailPanelWithLatestRow(rows);
                                }
                            } else {
                                if (!rowExist) {
                                    loadDetailPanelWithLatestRow(rows);
                                } else {
                                    renderActive();
                                }
                            }
                        } else {
                            mem.pageData.detailPanel.dataItem = null;
                            mem.pageData.detailPanel.title = '';
                        }
                    }


                    readOptions.success(res);
                    mem.pageData.grid.testFilter = true;

                    mem.pageData.grid_refreshing = false;
                    // mem.pageData.grid.resize();
                    if (selectService) {
                        selectService.reconcileSelected(res);
                    }
                }, function (res) {
                    readOptions.error(res);
                });
            }

            function loadDetailPanelWithLatestRow(rows) {
                showDetailView(lodash.first(rows));
                emitDataItemEvent('preview', lodash.first(rows));
            }

            function prepareDatasource(datasource) {
                if (lodash.has(datasource, 'transport.read')) {
                    if (lodash.has(datasource.transport.read, 'url')) {
                        mem.url = datasource.transport.read.url;
                        datasource.transport.read = readGrid;
                    }
                }
                return datasource;
            }

            function setDatasourceUrl(url) {
                mem.url = url;
            }

            function prepareGridOption(gridOption) {
                if (lodash.has(mem, 'options.toolbar')) {
                    const hideColumns = lodash.get(mem, 'options.toolbar.hideSelection', false);
                    if (!hideColumns) {
                        gridOption.columns = addSelectColumn(gridOption.columns);
                    }
                }

                if (lodash.has(gridOption, 'rowTemplate') && gridOption.columns.length === 0) {
                    gridOption.columns.push({field: 'template'});
                }


                if (lodash.has(mem, 'options.detail_panel') && mem.options.detail_panel) {
                    gridOption.change = gridChange;
                    gridOption.selectable = lodash.get(gridOption, 'selectable', 'row');

                }
                gridOption.dataBound = gridDataBoundDetailPanel;

                //}
                return gridOption;
            }

            function gridDataBoundDetailPanel(e) {
                // closeDetailPanel();
                if (lodash.has(mem, 'options.detail_panel') && mem.options.detail_panel) {
                    if (!lodash.isEmpty(mem.pageData.detailPanel.dataItem)) {
                        const updated = lodash.find(this._data, {select_id: mem.pageData.detailPanel.dataItem.select_id});
                        if (updated) {
                            mem.pageData.detailPanel.dataItem = updated;
                        }
                    }
                }
            }

            function gridChange(e) {
                const previousState = mem.pageData.detailPanel.toggleState;
                mem.pageData.detailPanel.toggleState = true;
                // get the selected data
                mem.pageData.detailPanel.dataItem = mem.pageData.grid.dataItem(this.select());
                mem.pageData.detailPanel.title = lodash.get(mem.pageData.detailPanel.dataItem, mem.pageData.detailPanel.titleField, '');
                if (lodash.has(mem.pageData.detailPanel, 'hideColumnsOnActive') && mem.pageData.detailPanel.hideColumnsOnActive.length > 0) {
                    mem.pageData.detailPanel.hideColumnsOnActive.map(function (fieldName) {
                        mem.pageData.grid.hideColumn(fieldName);
                    });
                }
                e.sender.$angular_scope.$apply();

                if (previousState) {
                    $timeout(function () {
                        mem.pageData.detailPanel.refresh();
                    });
                }
            }

            function showDetailView(dataItem) {
                const previousState = mem.pageData.detailPanel.toggleState;
                mem.pageData.detailPanel.toggleState = true;
                mem.pageData.detailPanel.dataItem = dataItem;
                mem.pageData.detailPanel.title = lodash.get(mem.pageData.detailPanel.dataItem, mem.pageData.detailPanel.titleField, '');
                if (lodash.has(mem.pageData.detailPanel, 'hideColumnsOnActive') && mem.pageData.detailPanel.hideColumnsOnActive.length > 0) {
                    mem.pageData.detailPanel.hideColumnsOnActive.map(function (fieldName) {
                        mem.pageData.grid.hideColumn(fieldName);
                    });
                }
                if (previousState || lodash.get(mem, 'options.detail_panel.always_on', false) === true) {
                    $timeout(function () {
                        mem.pageData.detailPanel.refresh();
                        if (typeof mem.pageData.detailPanel.refreshHeader === typeof function () {
                        }) {
                            mem.pageData.detailPanel.refreshHeader();
                        }
                    });
                }
                angular.element('body').addClass('grid-detail-panel-active');

                renderActive();
            }

            function hideDetailView() {
                closeDetailPanel();
            }

            function renderActive() {
                var data = [];
                if (lodash.has(mem, 'pageData.grid.dataSource.data')) {
                    data = mem.pageData.grid.dataSource.data();

                    var dataItem = lodash.get(mem, 'pageData.detailPanel.dataItem', {});
                    _.forEach(document.querySelectorAll('[data-id]'), (function (data) {
                        return function (oRow) {
                            var elemDataId = oRow.getAttribute('data-id');
                            var foundDataId = lodash.find(data, {select_id: elemDataId});
                            if (!!foundDataId) oRow.className = '';
                        }
                    })(data));

                    var filteredData = lodash.filter(data, {select_id: lodash.get(dataItem, 'select_id', -1)});
                    _.forEach(filteredData, function (oFilterData) {
                        var selectedRow = document.querySelector('[data-id="' + oFilterData.select_id + '"]');
                        if (selectedRow) {
                            selectedRow.className = 'active';
                        }
                    });
                }
            }

            function addSelectColumn(columns) {
                const selectColumns = [];

                if (lodash.get(mem.pageData, 'toolbar.hasSelectionButton', false) && !mem.pageData.toolbar.hideSelectAll) {
                    selectColumns.push({
                        headerTemplate: '<list-filter-select-all flag="vm.pageData.toolbar.selection.selectAllFlag"></list-filter-select-all>',
                        template: '<list-filter-select data-item="dataItem"></list-filter-select>',
                        width: '42px',
                        attributes: {
                            "class": "text-center"
                        },
                        headerAttributes: {
                            "class": "text-center"
                        }
                    });
                }

                return selectColumns.concat(columns);
            }

            function generateResourceOption(resourceData, myData, method) {
                var params = {};
                params = angular.merge(params, resourceData, myData);
                if (method == 'search') {
                    params = {'data': params};
                }
                return params;
            }

            function toggleSelectRow(dataItem) {
                selectService.toggleSelectRow(dataItem);
            }

            function toggleSelectAll() {
                selectService.toggleSelectAll();
            }

            function refreshGrid(resetToPageOne) {
                if (lodash.has(mem.pageData, 'grid.dataSource')) {
                    if (resetToPageOne) {
                        mem.pageData.grid.dataSource.page(1);
                    } else {
                        mem.pageData.grid.dataSource.read().then(function () {
                        });
                    }
                }
            }

            // </editor-fold>

            function getFilterService() {
                return filterService;
            }

            function getSelectedModel(include_select_filters) {
                // Future implementation, schema will determine the data in selected.
                var selected = lodash.get(mem.pageData, 'toolbar.selection.selected', []).map(function (_s) {
                    return {id: _s.id};
                });

                return {
                    selected: selected,
                    selectAllFlag: lodash.get(mem.pageData, 'toolbar.selection.select_all', false),
                    filter: filterService.getAppliedFilters(),
                    isMassSelectedItems: true,
                    selectAllCount: lodash.get(mem.pageData, 'toolbar.selection.selection_count', selected.length),
                };
            }

            function getSelectedModelKeys($keys) {
                // Future implementation, schema will determine the data in selected.
                var selected = lodash.get(mem.pageData, 'toolbar.selection.selected', []).map(function (_s) {
                    return _s;
                });

                return {
                    selected: selected,
                    selectAllFlag: false,
                    filter: filterService.getAppliedFilters(),
                    isMassSelectedItems: true
                };
            }

            function clearSelected() {
                if (selectService) {
                    selectService.unselectAll();
                }
            }

            function closeDetailPanel() {

                if (mem.pageData.detailPanel) {
                    mem.pageData.detailPanel.toggleState = false;
                    mem.pageData.detailPanel.dataItem = null;

                    if (lodash.has(mem.pageData.detailPanel, 'hideColumnsOnActive') && mem.pageData.detailPanel.hideColumnsOnActive.length > 0) {
                        mem.pageData.detailPanel.hideColumnsOnActive.map(function (fieldName) {
                            mem.pageData.grid.showColumn(fieldName);
                        });
                    }
                    mem.pageData.grid.resize();
                }
                angular.element('body').removeClass('grid-detail-panel-active');

                renderActive();
            }

            function toggleFilterSidebar() {
                if (mem.pageData.sidebar_active !== undefined) {
                    mem.pageData.sidebar_active = !mem.pageData.sidebar_active;
                    $timeout(function () {
                        vm.pageData.grid.resize();
                    });
                }
            }

            function updateToolbarButtons(status) {
                if (!lodash.has(mem.options, 'status_selection.selection_button_rules')) {
                    return;
                }
                let statusKey = "0";
                if (!!status) {
                    statusKey = status.value.toString();
                }
                const selectedStatus = lodash.find(mem.options.status_selection.selection_button_rules, function (value) {
                    return value.key.toString() === statusKey;
                });
                const selectionButtons = selectedStatus.rules.selection.map(function (actionName) {
                    return lodash.find(mem.options.toolbar.selection.conditionals, {name: actionName});
                });
                const additionals = selectedStatus.rules.additionals.map(function (a) {
                    const additional = Object.assign({}, a);
                    additional.actions = a.actions.map(function (actionName) {
                        return lodash.find(mem.options.toolbar.selection.conditionals, {name: actionName});
                    });
                    return additional;
                });

                const buttons = lodash.get(mem.options.toolbar, 'selection.buttons', []);

                lodash.set(mem.pageData.toolbar.selection, 'buttons', buttons.concat(selectionButtons));
                lodash.set(mem.pageData.toolbar.selection, 'additionals', additionals);
            }

            function setExternalGridRefreshFunc(func) {
                mem.gridRefreshFunc = func;
            }

            function triggerExternalGridRefreshFunc() {
                if (lodash.has(mem, 'gridRefreshFunc') && typeof mem.gridRefreshFunc === typeof function () {
                }) {
                    mem.gridRefreshFunc();
                }
            }

            function getData(path) {
                return lodash.get(mem.pageData, path, null);
            }

            function setData(path, value) {
                return lodash.set(mem.pageData, path, value);
            }

            function updateRecord(record) {
                var data = lodash.find(mem.pageData.grid.dataSource.data(), {[record.record_key]: record.record_id});
                // lodash.set(data, record.data, {});
                if (data) {
                    angular.merge(data, record.data);
                } else {
                    refreshGrid();
                }
                // return mem.pageData.grid.dataSource.pushUpdate(record);
                return true;
            }

            function getAllDataItems() {
                return mem.pageData.grid.dataSource.data();
            }

            function setExternalStatus(status) {
                lodash.set(mem.pageData, 'externalStatus', status);
            }

            function getExternalStatus() {
                return lodash.get(mem.pageData, 'externalStatus', null);
            }

            function getGrid() {
                return mem.pageData.grid;
            }

            function setSearchText(searchText) {
                lodash.set(mem.pageData, 'toolbar.searchText', searchText);
            }

            function toggleSelectable(state) {
                lodash.set(mem.pageData, 'toolbar.hideSelectAll', !state);
                lodash.set(mem.pageData, 'toolbar.hasSelectionButton', state)
            }

            function setPage(page) {
                var grid = this.getGrid();
                if (grid.pager) {
                    grid.pager.page(page);
                }
            }

            function getCurrentPipeline() {
                var applied_filters = filterService.getAppliedFilters();
                return applied_filters.pipeline;
            }

            function setPipelineData($data) {
                mem.pageData.pipelines = $data;
            }

            function getPipelineData() {
                return mem.pageData.pipelines;
            }

            function getHasPipeline() {
                return lodash.has(mem.options, 'status_selection');
            }
        };
    }
})();
